import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarDays, MapPin } from 'lucide-react';
import { getImageUrl } from '../../../utils/imageUtils';

const EventsSection = ({ events }) => (
    <div className="rounded-2xl bg-white border border-secondary-200 shadow-soft p-5">
        <div className="flex items-center gap-2 mb-4">
            <CalendarDays className="w-5 h-5 text-primary-600" />
            <span className="text-sm font-semibold text-secondary-900">События пользователя</span>
        </div>
        <div className="grid grid-cols-1 gap-4">
            {events.map((ev) => (
                <Link
                    to={`/events/${ev.id}`}
                    key={ev.id}
                    className="rounded-xl border bg-white shadow-soft hover:shadow-lg transition p-3 flex flex-col gap-2"
                >
                    {ev.image_url && (
                        <img
                            src={getImageUrl(ev.image_url)}
                            alt={ev.title}
                            className="w-full object-cover rounded-lg mb-1"
                            loading="lazy"
                        />
                    )}
                    <div className="flex items-center gap-2 text-xs text-secondary-700">
                        <CalendarDays className="w-4 h-4" />
                        {ev.start_at && new Date(ev.start_at).toLocaleString('ru-RU', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                        })}
                    </div>
                    <div className="font-bold text-base text-secondary-900">{ev.title}</div>
                    <div className="flex items-center gap-2 text-xs text-secondary-700">
                        <MapPin className="w-4 h-4" />
                        {ev.venue && <span>{ev.venue}, </span>}
                        {ev.city}
                    </div>
                </Link>
            ))}
        </div>
    </div>
);

export default EventsSection;
